import type { AgentApiJobPostImportRequestsRecord } from '@/types/serializers';
import { Button } from '@/components/Button';
import { Link } from '@tanstack/react-router';
import { MdKeyboardArrowRight, MdErrorOutline } from 'react-icons/md';

type Props = {
  importRequest: AgentApiJobPostImportRequestsRecord;
};

export function JobPostImportRequestsFailedTemplate({ importRequest }: Props) {
  const metaError = importRequest.meta?.error;
  const errorMessage =
    typeof metaError === 'string' ? metaError : '取り込み処理中にエラーが発生しました。';

  return (
    <div className="flex h-full flex-col items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4">
        <MdErrorOutline size={24} className="text-red-600" />
        <div className="text-center">
          <h2 className="text-lg font-semibold text-gray-900">取り込みに失敗しました</h2>
          <p className="mt-2 text-sm text-gray-600">{errorMessage}</p>
        </div>
        <div className="mt-4 flex gap-3">
          <Button color="tertiary" size="md" asChild>
            <Link
              to="/agent/provided_job_posts"
              className="flex items-center gap-1"
              target="_blank"
            >
              <span>求人票一覧へ</span>
              <MdKeyboardArrowRight size={16} />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
